module.exports = __webpack_public_path__ + "static/img/top10RewardsBg.feb494e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DiwaliFestival/top10RewardsBg.png
// module id = TKxF
// module chunks = 0